
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class PendingOrdersDialog extends Serenity.EntityDialog<PendingOrdersRow, any> {
        protected getFormKey() { return PendingOrdersForm.formKey; }
        protected getIdProperty() { return PendingOrdersRow.idProperty; }
        protected getLocalTextPrefix() { return PendingOrdersRow.localTextPrefix; }
        protected getNameProperty() { return PendingOrdersRow.nameProperty; }
        protected getService() { return PendingOrdersService.baseUrl; }
        protected getDeletePermission() { return PendingOrdersRow.deletePermission; }
        protected getInsertPermission() { return PendingOrdersRow.insertPermission; }
        protected getUpdatePermission() { return PendingOrdersRow.updatePermission; }

        protected form = new PendingOrdersForm(this.idPrefix);
        private orderGrid: Orders.OrdersGrid1;
        private pendingOrderGrid: PendingOrdersGrid1;
        private enquiryGrid: EnquiryGrid1;
        private loadedState: string;
        constructor() {
            super();

            //this.orderProductSpecificationsGrid = new OrderProductSpecificationsGrid(this.byId("OrderProductSpecificationsGrid"));
            //this.orderProductSpecificationsGrid.element.flexHeightOnly(1);

            this.orderGrid = new Orders.OrdersGrid1(this.byId("OrdersGrid1"));
            this.orderGrid.element.flexHeightOnly(1);

            this.pendingOrderGrid = new PendingOrdersGrid1(this.byId("PendingOrdersGrid1"));
            this.pendingOrderGrid.element.flexHeightOnly(1);

            this.enquiryGrid = new EnquiryGrid1(this.byId("EnquiryGrid1"));
            this.enquiryGrid.element.flexHeightOnly(1);

           
            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
            this.tabs.on('tabsactivate', (e, i) => { this.arrange() });
            

            
        }
        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'UnpaidOrders', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'PaidOrders', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'Enquiries', this.isNewOrDeleted());

            this.loadedState = this.getSaveState();
        }

        loadEntity(entity: PendingOrdersRow) {
            super.loadEntity(entity);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'UnpaidOrders', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'PaidOrders', this.isNewOrDeleted());

            Serenity.TabsExtensions.setDisabled(this.tabs, 'Enquiries', this.isNewOrDeleted());
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // this.orderProductSpecificationsGrid.OrderId = this.entityId;
            this.orderGrid.CustomerId = this.entity.CustomerId;
            //this.orderShippingGrid.ShippingProviderId = this.entity.ShippingProviderId;
            this.pendingOrderGrid.CustomerId = this.entity.CustomerId;
            this.enquiryGrid.CustomerId = this.entity.CustomerId;
        }

    }
}